import React, { useEffect, useRef } from 'react'
import classes from '../../pages/Homepage/Dashboard.module.css'
import classNames from 'classnames'
import { ReactComponent as ArrowIcon } from '../../assets/icons/arrow-right.svg'
import classPlaceholder from '../../assets/images/class-placeholder.svg'
import Carousel from '../Carousel/Carousel'
import { ClassCard } from '../Cards/GeneralCard/Card'
import { convertToFormatted, getImageURL } from '../../util/functions'
import CardLoader from '../loaders/CardLoader'
import { useDispatch, useSelector } from 'react-redux'
import notification from '../Notification/notification'
import { getUpcomingClasses } from './ourClassesApi'
import { ourClassesSelectors } from './ourClassesSlice'
import TooltipWrapper from '../Tooltip/Tooltip'
import { CardTooltip } from '../Cards/GeneralCard/CardTooltip'
import { useHistory } from 'react-router-dom'

const OurClasses = () => {
    const classesPrevButton = useRef()
    const classesNextButton = useRef()

    const isFetching = useSelector(ourClassesSelectors.isFetching)
    const classesArray = useSelector(ourClassesSelectors.classes)
    const hasError = useSelector(ourClassesSelectors.hasError)

    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(getUpcomingClasses())
    }, [])

    useEffect(() => {
        if (hasError) {
            notification.failure({
                title: 'Something went wrong while fetching our classes',
            })
        }
    }, [hasError])

    return (
        <>
            <div className={classes.cardsCarousel}>
                <button
                    className={classNames(
                        classes.cardsButton,
                        classes.cardsButtonLeft
                    )}
                    ref={classesPrevButton}
                >
                    <ArrowIcon
                        className={classNames(
                            classes.cardsButtonIcon,
                            classes.cardsButtonIconLeft
                        )}
                    />
                </button>
                <Carousel
                    prevButton={classesPrevButton}
                    nextButton={classesNextButton}
                    slideClassName={classes.recommendedCourseCard}
                >
                    <Classes
                        isFetching={isFetching}
                        classesArray={classesArray}
                    />
                </Carousel>
                <button
                    className={classNames(
                        classes.cardsButton,
                        classes.cardsButtonRight
                    )}
                    ref={classesNextButton}
                >
                    <ArrowIcon className={classes.cardsButtonIcon} />
                </button>
            </div>
            <div className={classes.cardsGrid}>
                <Classes isFetching={isFetching} classesArray={classesArray} />
            </div>
        </>
    )
}

const Classes = ({ isFetching, classesArray }) => {
    const history = useHistory()

    if (isFetching) {
        return [...Array(6)].map((_, idx) => <CardLoader key={idx} />)
    }

    return classesArray.map(
        ({
            thumbnail,
            price,
            title,
            catName,
            enrolled,
            classid,
            startdate,
            starttime,
            location,
            status,
            coursedescription,
        }) => (
            <TooltipWrapper
                key={classid}
                tooltip={
                    <CardTooltip
                        title={title}
                        benefits={[
                            location,
                            convertToFormatted(price, true),
                            status,
                        ]}
                        description={coursedescription}
                        addToCartCustomText="LEARN MORE"
                        addToCart={() =>
                            history.push(`/app/browse/classes/${classid}`)
                        }
                        hideFavorite
                    />
                }
            >
                <ClassCard
                    url={thumbnail ? getImageURL(thumbnail) : classPlaceholder}
                    price={price}
                    title={title}
                    category={catName}
                    attendees={enrolled}
                    classid={classid}
                    date={startdate}
                    time={starttime}
                />
            </TooltipWrapper>
        )
    )
}

export default OurClasses
